import React from 'react';
import SessionManager from '../../routes/SessionManager';

const NavDropdownItem = props => {
    const pathname = window.location.pathname;
    const pageURI = pathname + window.location.search;
    let aClassName = props.disabled ? "nav-link disabled text-nowrap" : "nav-link text-nowrap";
    var content = props.name;

    if (aClassName === 'nav-link text-nowrap')
        if (props.path === (pathname))
            aClassName += ' active';

    if (props.auth && (props.path === pageURI)) {
        var sessionManager = new SessionManager()
        const user = sessionManager.readCookie('user');
        const isSessionValid = user ? (user.token_expiry - (new Date().getTime()) > 0) : false;
        //console.log('Token Expiry : ' + user.token_expiry + ', Now : ' + (new Date().getTime()));
        if (!isSessionValid) {
            sessionManager.removeCookie('user');
            window.location = './login';
        }
    }

    return (
        <a href={props.path ? props.path : "#"} className={aClassName} id={props.id}>
            {content}
            {(props.path === pageURI) ? (<span key={props.x} className="sr-only">(current)</span>) : ''}
        </a>
    );
}

export default NavDropdownItem;